import { useState } from "react";
import useGet from "./read/useGet";

const INITIAL_PARAMS = { screen: "hrms" };

const useHasProductAccess = () => {
  const [hasAccess, setHasAccess] = useState(false);

  const { list } = useGet({
    url: `is_permission_for_product`,
    returnEntireResponse: true,
    onSuccess: (data) => {
      if (data.status === 200) {
        setHasAccess(true);
      }
    },
    onError: (err) => {
      if (err.response?.status === 403) {
        setHasAccess(false);
        document.body.style.overflow = "hidden";
      }
    },
    initialData: INITIAL_PARAMS,
  });
  const { isLoading: isCheckingAccess } = list;
  const resolvedHasAccess = hasAccess || list?.data?.status === 200;
  const companyCompletionStatus = list?.data?.data?.data?.company_completion_status || list?.data?.data?.company_completion_status;

  return { isCheckingAccess, hasAccess: resolvedHasAccess, companyCompletionStatus };
};

export default useHasProductAccess;
